/*@ngInject*/
const baseSubmissionGridController = function ($rootScope, $controller, $scope, appTypeConfigurationModel, authorizationConstants,
		coreConstant, submissionGridConstant, gridColumnModel, loadSubmissionsRepository,
		persistentConnection, uiPerformanceLoggerConstant, currentUserModel)
{

    angular.extend(this, $controller('baseGridWidgetController', {$scope: $scope}));

    this.userId = null;
    this.customIconPreferences = {};
    this.columnPreference = this.isAgent ? 'view.agent.homePageColumns' : 'view.uw.homePageColumns';

    this.$onInit = function () {
        this.initSubmissionGrid();
    };

    this.initSubmissionGrid = function () {
        this.uiPerformanceLogAction = uiPerformanceLoggerConstant.SUBMISSION_HOME;
        this.gridLoadedEvent = submissionGridConstant.event.SUBMISSIONS_LOADED;
        this.openDetailDrawerEvent = submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER;
        this.closeDetailDrawerEvent = submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER;
        this.requestParams = this.getFilterParams();
        this.hasFilterPermission = currentUserModel.hasAuthorization(authorizationConstants.AUTHORIZATION_ADVANCED_FILTER);

        this.onInitGridWidget();
    };

    this.loadRecordsInt = function (requestParams) {
        return loadSubmissionsRepository.loadSubmissions(this.requestParams);
    };

    this.updateDefaultSortColumn = function () {
        const submissionParams = gridColumnModel.getSubmissionParams();
        this.setFilterParams(submissionParams);
    };

    this.setFilterParams = function (filterParams) {
        gridColumnModel.setSubmissionParams(filterParams);
    };

    this.getFilterParams = function () {
        return gridColumnModel.getSubmissionParams();
    };

    this.setSelectedFilterName = function (filterName) {
        gridColumnModel.setSelectedSubmissionFilterName(filterName);
    };

    this.getSelectedFilterName = function () {
        return gridColumnModel.getSelectedSubmissionFilterName();
    };

    this.generateColumns = function (filterColumnPrefName=null) {
        this.updateColumnsFromPreferences();  // update the columnPreference in shared gridColumnModel
        this.colViewModel = gridColumnModel.getSubmissionGridColumns(filterColumnPrefName);
        this.dropdownColumns = gridColumnModel.getDropdownColumns(filterColumnPrefName);
    };

    this.resetParams = function (params) {
        gridColumnModel.setSubmissionParams(params);
    };

    this.getNextTaskDefinition = function (definition) {
        return _.replace(_.replace(definition, 'Other::', ''), 'Other - ', '');
    };

};

angular.module('gw-um-submission-grid')
    .controller('baseSubmissionGridController', baseSubmissionGridController);
